// eslint-disable-next-line import/prefer-default-export
export const LANGUAGES = {
  uk: 'uk',
  ru: 'ru',
};
